import * as firebase from 'firebase/app';
import {GroupPath} from "./GroupPath";

export class SmileList {
    constructor(
        private firestoreInstance: firebase.firestore.Firestore,
        private groupPath: GroupPath
    ) {

    }

    async* makeIterator() {
        const fs = this.firestoreInstance;

        let allCount = 0;
        let doneCount = 0;
        let undoneCount = 0;
        let undefinedCount = 0;

        try {
            let lastVisible: (firebase.firestore.QueryDocumentSnapshot<firebase.firestore.DocumentData> | null) = null;

            while (true) {
                const groupPath = this.groupPath.value;
                let query = fs
                    .collection(groupPath)
                    .orderBy('timestamp', 'desc');

                if (lastVisible) {
                    query = query.startAfter(lastVisible);
                }

                query = query.limit(10);

                const documentSnapshots = await query.get();

                // console.log('documentSnapshots',documentSnapshots.size,documentSnapshots.docs.length);

                // console.log('documentSnapshots.docs.length',documentSnapshots.docs.length);
                if (documentSnapshots.docs.length > 0) {
                    lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
                } else {
                    lastVisible = null;
                    // console.log('finish');
                    break;
                }

                for (let i of documentSnapshots.docs) {
                    allCount++;

                    const data = i.data();

                    if(data.isDone===false){
                        undoneCount++;
                        continue;
                    }

                    if(data.isDone==undefined){
                        undefinedCount++;
                    }

                    doneCount++;

                    yield {id: i.id, data: data};
                }
            }
        } catch (e) {
        }

        console.info('[ SmileList.makeIterator ] smiles all =', allCount);
        console.info('[ SmileList.makeIterator ] smiles done =', doneCount);
        console.info('[ SmileList.makeIterator ] smiles undefined =', undefinedCount);
        console.info('[ SmileList.makeIterator ] smiles undone =', undoneCount);

        yield null;
    }

}